var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.028,
    height: 24.987,
    viewBox: "0 0 28.028 24.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.274,
    y1: 0.363,
    x2: 0.895,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96b4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5682fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.707,
    y1: 0.204,
    x2: -0.293,
    y2: 1.635,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.761,
    y1: 0.152,
    x2: 0.453,
    y2: 0.563,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.169,
    y1: -0.343,
    x2: 0.648,
    y2: 0.878,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.122,
    y1: 2.096,
    x2: 0.853,
    y2: -0.405,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#ebeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.77,
    y1: 0.088,
    x2: -0.679,
    y2: 2.118,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.149,
    y1: 0.072,
    x2: 1.556,
    y2: 1.304,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febc4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.329,
    y1: 0.554,
    x2: -0.255,
    y2: 0.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#fdba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#ffc244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#f99c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.727,
    y1: 0.007,
    x2: 0.207,
    y2: 1.135,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feef06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.636,
    y1: 1.231,
    x2: 0.531,
    y2: 0.666,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.409,
    y1: 0.31,
    x2: 0.858,
    y2: 1.247,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.253,
    y1: 0.019,
    x2: 0.711,
    y2: 1.039,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.464,
    y1: 0.369,
    x2: 1.215,
    y2: 1.306,
    xlinkHref: "#linear-gradient-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69255",
    "data-name": "Group 69255",
    transform: "translate(-492.903 -897.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(497.674 897.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69253",
    "data-name": "Group 69253",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69231",
    "data-name": "Group 69231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58478",
    "data-name": "Path 58478",
    d: "M620.443,909c.013,6.074-3.215,11.03-8.964,11.193-.089,0-1.556,0-1.646,0a11.181,11.181,0,0,1-.049-22.335c.137,0,1.427.012,1.563.017C617.03,898.085,620.429,902.973,620.443,909Z",
    transform: "translate(-599.173 -897.855)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3726",
    "data-name": "Ellipse 3726",
    cx: 10.635,
    cy: 11.167,
    rx: 10.635,
    ry: 11.167,
    transform: "translate(1.988 0.1)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3727",
    "data-name": "Ellipse 3727",
    cx: 10.367,
    cy: 10.886,
    rx: 10.367,
    ry: 10.886,
    transform: "translate(2.256 0.381)",
    opacity: 0.3,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3728",
    "data-name": "Ellipse 3728",
    cx: 10.054,
    cy: 10.557,
    rx: 10.054,
    ry: 10.557,
    transform: "translate(2.569 0.71)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3729",
    "data-name": "Ellipse 3729",
    cx: 9.839,
    cy: 10.332,
    rx: 9.839,
    ry: 10.332,
    transform: "translate(2.569 0.936)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69229",
    "data-name": "Group 69229",
    transform: "translate(13.447 2.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58479",
    "data-name": "Path 58479",
    d: "M1925.289,1160.016l7.495,2.906a9.121,9.121,0,0,0,.375-2.6,8.542,8.542,0,0,0-7.87-8.7Z",
    transform: "translate(-1925.289 -1151.618)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69230",
    "data-name": "Group 69230",
    transform: "translate(1.988 0.547)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58480",
    "data-name": "Path 58480",
    d: "M803.2,962.3c-.778-2.52,2.035-4.338,1.591-7.276a5.522,5.522,0,0,0-1.894-3.21,11.112,11.112,0,0,0-7.647,10.746A10.908,10.908,0,0,0,805.909,973.7a10.165,10.165,0,0,0,4.064-.856c-.181-3.564-1.275-5.578-2.437-6.791C805.744,964.188,803.793,964.224,803.2,962.3Z",
    transform: "translate(-795.25 -951.817)",
    fill: "#e3ebff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3730",
    "data-name": "Ellipse 3730",
    cx: 0.626,
    cy: 0.657,
    rx: 0.626,
    ry: 0.657,
    transform: "translate(11.755 10.772)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58481",
    "data-name": "Path 58481",
    d: "M1781.523,1508.706a.406.406,0,0,0-.4.415v4.428a.4.4,0,1,0,.791,0v-4.428A.406.406,0,0,0,1781.523,1508.706Z",
    transform: "translate(-1769.143 -1502.512)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58482",
    "data-name": "Path 58482",
    d: "M1107.489,1814.554l-7.083-2.083a.251.251,0,0,0-.306.155.224.224,0,0,0,.146.293l7.083,2.082a.251.251,0,0,0,.306-.155A.223.223,0,0,0,1107.489,1814.554Z",
    transform: "translate(-1095.007 -1803.187)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69254",
    "data-name": "Group 69254",
    transform: "translate(492.903 909.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69216",
    "data-name": "Group 69216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58458",
    "data-name": "Path 58458",
    d: "M815.187,867.828a6.159,6.159,0,0,1-6.372,6.281,7.212,7.212,0,0,1-6.85-7.173,6.142,6.142,0,0,1,6.85-6.249A7.259,7.259,0,0,1,815.187,867.828Z",
    transform: "translate(-801.965 -860.343)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58459",
    "data-name": "Path 58459",
    d: "M853.261,855.673a6.16,6.16,0,0,1-6.372,6.281,7.212,7.212,0,0,1-6.85-7.173,6.142,6.142,0,0,1,6.85-6.249A7.259,7.259,0,0,1,853.261,855.673Z",
    transform: "translate(-839.073 -848.497)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58460",
    "data-name": "Path 58460",
    d: "M865.394,867.5A5.878,5.878,0,0,1,859.3,873.5a6.884,6.884,0,0,1-6.526-6.845,5.862,5.862,0,0,1,6.526-5.965A6.927,6.927,0,0,1,865.394,867.5Z",
    transform: "translate(-851.487 -860.344)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58461",
    "data-name": "Path 58461",
    d: "M874.034,875.948a5.677,5.677,0,0,1-5.89,5.79,6.649,6.649,0,0,1-6.3-6.611,5.662,5.662,0,0,1,6.3-5.762A6.689,6.689,0,0,1,874.034,875.948Z",
    transform: "translate(-860.328 -868.804)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69215",
    "data-name": "Group 69215",
    transform: "translate(4.76 1.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58462",
    "data-name": "Path 58462",
    d: "M992.6,914.849h0a.36.36,0,0,1,.318.353v.609a8.964,8.964,0,0,1,1.055.183q.39.092.774.218a.356.356,0,0,1,.243.365l-.075.763a.286.286,0,0,1-.409.237,4.426,4.426,0,0,0-.519-.193,4.71,4.71,0,0,0-.979-.183l-.09-.007v1.744a4.578,4.578,0,0,1,2.024,1.035,2.187,2.187,0,0,1,.648,1.616,2.127,2.127,0,0,1-.717,1.68,3.271,3.271,0,0,1-2.028.714v.672a.306.306,0,0,1-.318.31h-.006a.338.338,0,0,1-.319-.337v-.663l-.142-.006a9.331,9.331,0,0,1-1.175-.125,7.607,7.607,0,0,1-.812-.187.35.35,0,0,1-.255-.362l.088-.981a.31.31,0,0,1,.434-.256,6.379,6.379,0,0,0,.714.234,6.264,6.264,0,0,0,1.142.191l.005-1.94a4.2,4.2,0,0,1-1.971-.967,2.215,2.215,0,0,1-.653-1.646,1.924,1.924,0,0,1,.708-1.6,3.139,3.139,0,0,1,2-.557v-.623A.288.288,0,0,1,992.6,914.849Zm-.319,2.327a1.074,1.074,0,0,0-.635.224.654.654,0,0,0-.228.523.7.7,0,0,0,.211.52,1.493,1.493,0,0,0,.653.333Zm.564,3.512v1.779a.984.984,0,0,0,.68-.211.762.762,0,0,0,.237-.6.817.817,0,0,0-.22-.585A1.614,1.614,0,0,0,992.845,920.688Z",
    transform: "translate(-989.579 -914.847)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_58463",
    "data-name": "Path 58463",
    d: "M867.076,878c.2-1.966,2.005-2.8,1.77-4.606a4.556,4.556,0,0,0-1.932-2.787,5.663,5.663,0,0,0-5.068,5.761,6.65,6.65,0,0,0,6.3,6.611,5.937,5.937,0,0,0,.973-.048A6.434,6.434,0,0,1,867.076,878Z",
    transform: "translate(-860.327 -870.043)",
    opacity: 0.3,
    fill: "url(#linear-gradient-15)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilization);
export default __webpack_public_path__ + "static/media/utilization.adbfb049c7689feb04d05021d22a9a8a.svg";
export { ForwardRef as ReactComponent };